import { Box, BoxProps } from "styled-system/jsx";

export const Shimmer = ({ ...props }: BoxProps) => {
  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -500px 0;
            }
            100% {
              background-position: 500px 0;
            }
          }
        `}
      </style>
      <Box
        bg="linear-gradient(to right,var(--wa-colors-ink-100) 5%,var(--wa-colors-ink-300) 20%,var(--wa-colors-ink-100) 35%)"
        bgSize="200% 100%"
        borderRadius="100"
        animation="shimmer 2s linear 0s infinite normal forwards"
        {...props}
      />
    </>
  );
};
